import BaseModal from "@components/modals/BaseModal";
import Button from "@components/ui/buttons/Button";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import AreaTextField from "@components/ui/textfields/AreaTextField";
import CheckBoxInput from "@components/ui/selection/CheckBoxInput";
import Icon1 from "@assets/icons/Icon";
import { useState } from "react";

function formatDateFr(seconds: number): string {
  return new Date(seconds * 1000).toLocaleDateString("fr-FR", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const QUICK_REASONS = [
  "Pièces en attente de livraison",
  "Travaux supplémentaires nécessaires",
  "Retard fournisseur",
  "Véhicule prêt plus tôt que prévu",
  "Demande du client",
];

interface RestitutionChangeConfirmModalProps {
  oldSeconds?: number;
  newSeconds: number;
  onClose: () => void;
  onConfirm: (comment: string, notify: boolean) => void;
  saving?: boolean;
  kind?: "restitution" | "reception";
}

export default function RestitutionChangeConfirmModal({
  oldSeconds,
  newSeconds,
  onClose,
  onConfirm,
  saving,
  kind = "restitution",
}: RestitutionChangeConfirmModalProps) {
  const [comment, setComment] = useState("");
  const [notify, setNotify] = useState(true);

  return (
    <BaseModal
      title={kind === "reception" ? "Changement d'heure de réception" : "Changement de date de restitution"}
      startIcon={<Icon1 name="horloge" size={20} />}
      onClose={onClose}
      width="max-w-md"
    >
      <div className="flex flex-col gap-4 p-4">
        <div className="flex flex-col gap-2">
          {oldSeconds ? (
            <div className="flex flex-col gap-1">
              <div className="text-h4 text-neutral-400">Ancienne date</div>
              <div className="text-h3 text-neutral-600">
                {formatDateFr(oldSeconds)}
              </div>
            </div>
          ) : null}
          <div className="flex flex-col gap-1">
            <div className="text-h4 text-neutral-400">Nouvelle date</div>
            <div className="text-h3 font-medium text-black">
              {formatDateFr(newSeconds)}
            </div>
          </div>
        </div>

        <CheckBoxInput
          label="Notifier le client du changement"
          checked={notify}
          onChange={(e) => setNotify(e.target.checked)}
        />

        {notify && (
          <div className="flex flex-col gap-2">
            <div className="flex flex-row flex-wrap gap-1.5">
              {QUICK_REASONS.map((reason) => (
                <button
                  key={reason}
                  className="px-2.5 py-1 rounded-lg text-h4 border transition-colors"
                  style={{
                    background: comment === reason ? "#262626" : "#F5F5F5",
                    color: comment === reason ? "#FFFFFF" : "#525252",
                    borderColor: comment === reason ? "#262626" : "#E5E5E5",
                  }}
                  onClick={() => setComment(comment === reason ? "" : reason)}
                >
                  {reason}
                </button>
              ))}
            </div>
            <AreaTextField
              label="Justification (optionnel)"
              placeholder="Raison du changement de date..."
              value={comment}
              onChange={setComment}
              rows={3}
            />
          </div>
        )}
      </div>

      <div className="border-t p-4 flex flex-row justify-end gap-2">
        <SecondaryButton variant="small" onClick={onClose}>
          Annuler
        </SecondaryButton>
        <Button
          variant="small"
          label={saving ? "Enregistrement..." : "Confirmer"}
          onClick={() => onConfirm(comment, notify)}
          disabled={saving}
        />
      </div>
    </BaseModal>
  );
}
